import BusinessPage from './BusinessPage.jsx';
import BusinessPageWithSlug from './BusinessPageWithSlug.jsx';
import RegisterBusiness from './RegisterBusiness.jsx';
import PhuyenBusinessPage from './PhuyenBusinessPage.jsx';

export {
  BusinessPage,
  RegisterBusiness,
  BusinessPageWithSlug,
  PhuyenBusinessPage
};



// WEBPACK FOOTER //
// ./pages/businesses/index.js